import React, { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDrag } from 'react-dnd';
import { useCustomModuleState } from '../Context/index';

function SectionControl({ handleAddCanvas, customModulePageList, pageLoading }) {
  const { customModuleState } = useCustomModuleState();
  const { t } = useTranslation('common');
  const { leftColumn, controlPanelOpen } = customModuleState;
  const [forActiveClass, setForActiveClass] = useState([]);

  function MovableItem({ ele }) {
    const [{ isDragging }, drag] = useDrag({
      type: ele?.type,
      item: { ...ele },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });
    const opacity = isDragging ? 0.5 : 1;
    return (
      <div ref={drag} style={{ opacity }} key={ele.id}>
        {ele?.label}
      </div>
    );
  }

  const forActivekey = (e) => {
    if (forActiveClass?.includes(e?.target?.name)) {
      const nameArray = [...forActiveClass];
      const changedArray = nameArray.filter((ele) => {
        return ele !== e?.target?.name;
      });
      setForActiveClass([...changedArray]);
    } else {
      const nameArray = [...forActiveClass];
      nameArray.push(e?.target?.name);
      setForActiveClass([...nameArray]);
    }
  };
  const hasContentPage = customModulePageList?.pages?.filter((ele) => ele?.isContectPage === true);

  return (
    <div className={`${controlPanelOpen ? 'menu-open' : ''} left-section`}>
      <div className="move-cursor">
        <Card className="custom-card cm-control">
          <Card.Header>Page Controls</Card.Header>
          <Card.Body>
            <div className="canvas-container">
              {leftColumn?.map((item) => {
                return item?.canvas?.map((ele, index) => {
                  return (
                    <button
                      type="button"
                      key={`${ele?.id}_${index}`}
                      onClick={() => handleAddCanvas(ele?.key)}
                      aria-label={t(`CUSTOM_MODULE.${ele?.label}`)}
                      className="btn btn-default"
                      disabled={pageLoading || (ele?.key === 'content_page' && hasContentPage?.length > 0)}
                    >
                      {t(`CUSTOM_MODULE.${ele?.label}`)}
                    </button>
                  );
                });
              })}
            </div>
          </Card.Body>
        </Card>

        <Accordion>
          <Card className="border-0 rounded-0">
            <Accordion.Toggle
              variant="link"
              eventKey="1"
              name="OutherControls"
              onClick={(e) => {
                forActivekey(e);
              }}
              className={`d-flex btn-custom-module-tab ${forActiveClass.includes('OutherControls') ? 'active' : ''}`}
            >
              {t('CUSTOM_MODULES.LIBRARY.SECTION_CONTROL.OTHER_CONTROL')}
              <span className="ml-auto pointer-event-none">
                {forActiveClass.includes('OutherControls') ? <span className="icon-remove" /> : <span className="icon-add" />}
              </span>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <ul className="mb-0 pl-0" style={{ listStyle: 'none' }}>
                {leftColumn?.map((item) => {
                  return item?.components?.map((ele, componentIndex) => {
                    return (
                      <li key={`${ele?.id}_${componentIndex}`} className="po-tab-item">
                        <MovableItem ele={ele} />
                      </li>
                    );
                  });
                })}
              </ul>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </div>
  );
}
export default SectionControl;
